import FeatureRecord from './FeatureRecord.js';
import FeatureReference from './FeatureReference.js';
import FeatureReferenceCollection from './FeatureReferenceCollection.js';
import FeatureReferenceQuery from './FeatureReferenceQuery.js';
import FeatureReferenceQueryPatternType from './FeatureReferenceQueryPatternType.js';
import FeatureReferenceSourceType from './FeatureReferenceSourceType.js';
import LayerReference from './LayerReference.js';
import patterns from './patterns.js';
const features = {
    FeatureRecord,
    FeatureReference,
    FeatureReferenceCollection,
    FeatureReferenceQuery,
    FeatureReferenceQueryPatternType,
    FeatureReferenceSourceType,
    LayerReference,
    patterns,
};
/**
 * @namespace feature-references
 */
export { FeatureRecord, FeatureReference, FeatureReferenceCollection, FeatureReferenceQuery, FeatureReferenceQueryPatternType, FeatureReferenceSourceType, LayerReference, patterns, };
export default features;
